/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Footer_ProductInputs */

const en_landing_footer_product = /** @type {(inputs: Landing_Footer_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product`)
};

const zh_landing_footer_product = /** @type {(inputs: Landing_Footer_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`产品`)
};

/**
* | output |
* | --- |
* | "Product" |
*
* @param {Landing_Footer_ProductInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_footer_product = /** @type {((inputs?: Landing_Footer_ProductInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Footer_ProductInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_footer_product(inputs)
	return zh_landing_footer_product(inputs)
});
export { landing_footer_product as "landing.footer.product" }